<template>
  <span>{{ message }}</span>
</template>

<script>
import HOME from "@/api/sync/home";
import axios from "axios";

export default {
  name: "smtp-test",
  props: { smtp: { type: Object } },
  data() {
    return {
      state: undefined
    };
  },
  computed: {
    message: vm =>
      vm.state === undefined
        ? "正在发送测试邮件..."
        : `测试邮件发送${vm.state ? "成功" : "失败"}。`
  },
  async created() {
    this.source = axios.CancelToken.source();
    let response = await HOME.NOTICE_SEND_TEST(
      { smtp: this.smtp },
      { cancelToken: this.source.token }
    );
    this.state = response.data?.state;
    if (this.state === false) {
      console.log("邮件发送失败原因：");
      console.dir(response.data.message);
    }
  },
  destroyed() {
    this.source.cancel("测试邮件发送取消");
  }
};
</script>

<style scoped></style>
